import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { controlToastState, Modal } from "risa-oasis-ui_v2";
import { updateCmmInputTableData } from "../../../api/bigQuery/nycbsPharmaOrders";
import { NycbsStatus } from "../../../enums/nycbsStatus";
import { updateOrder } from "../../../redux/slice/nycbsPharmaExternal/nycbsPharmaOrder";
import { AppDispatch } from "../../../redux/store/store";
import CustomRadioButton from "../../customRadioButton/customRadioButton";

interface NycbsStatusModalProps {
  onClose: () => void;
  orderId: string;
  status: NycbsStatus;
}

const statusOptions = [
  { label: "Denied", value: NycbsStatus.DENIED },
  { label: "Approved", value: NycbsStatus.APPROVED },
  { label: "Decision Awaiting", value: NycbsStatus.DECSISION_PENDING },
];

const NycbsStatusModal = (props: NycbsStatusModalProps) => {
  const [selectedValue, setSelectedValue] = useState<number | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    //TODO : Add global error handler
    setLoading(true);
    try {
      const result = await updateCmmInputTableData(
        "identifier",
        props.orderId,
        [
          {
            field: "status",
            value: selectedValue?.toString() ?? "3",
          },
        ],
      );
      dispatch(updateOrder(props.orderId, result["details"][0]));
      controlToastState("status-changed-success");
    } catch (error) {
      controlToastState("status-changed-failure");
    } finally {
      props.onClose();
      setLoading(false);
    }
  };

  useEffect(() => {
    setSelectedValue(props.status);
  }, []);

  return (
    <Modal
      dialogId={"nycbs-status-modal"}
      onSave={handleSave}
      title={"Mark as Completed"}
      saveButtonText={loading ? "Updating..." : "Save"}
      cancelText={"Cancel"}
      onClose={props.onClose}
      disableSave={selectedValue === null || loading}
    >
      <div className="nycbs-status--container flex flex-col gap-3">
        <div className="nycbs-status--header text-small font-normal text-primaryGray-2">
          Select the Current Status of the Auth
        </div>
        <div className="nycbs-status--radio-btn-container">
          {statusOptions.map((option) => (
            <>
              <div key={`${option.value}_${option.label}`}>
                <CustomRadioButton
                  key={option.value}
                  name={"nycbs-status"}
                  value={option.value.toString()}
                  checked={selectedValue === option.value}
                  label={option.label}
                  onChange={function (
                    event: ChangeEvent<HTMLInputElement>,
                  ): void {
                    setSelectedValue(parseInt(event.target.value));
                  }}
                />
              </div>
            </>
          ))}
        </div>
        <div className="nycbs-status--info rounded bg-secondaryYellow-11 p-2 text-tiny font-normal">
          This case would be moved to Completed Tab
        </div>
      </div>
    </Modal>
  );
};

export default NycbsStatusModal;
